import { render } from "./OrderRescheduled.vue?vue&type=template&id=83dab842"
import script from "./OrderRescheduled.vue?vue&type=script&lang=js"
export * from "./OrderRescheduled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__